import React, { useEffect } from 'react';
import styled from 'styled-components';
import { isMobileOnly, isTablet } from 'react-device-detect';

const ControlButton = styled.p`
	user-select: none;
	color: var(--text-color) !important;
	cursor: pointer;
	font-family: ${({ theme }) => theme.fontFamily.primary};
	font-size: 0.813rem;
	font-weight: ${({ theme }) => theme.fontWeight.bold};
	line-height: 1rem;
	padding: 0 16px;
	position: relative;
	text-transform: uppercase;
	transition: color 0.3s;
	&:before {
		background-color: var(--text-color) !important;
		bottom: -2px;
		content: '';
		height: 1px;
		left: 16px;
		position: absolute;
		width: calc(100% - 26px);
	}
	&.both-sides {
		&:before {
			left: 10px;
			width: calc(100% - 20px);
		}
	}
`;
const CounterWrapper = styled.div`
	align-items: center;
	background-color: ${({ theme, pageTheme }) => (pageTheme === 'contrastMode' ? 'transparent' : theme.colors.greenAlpha32)};
	border-radius: 100px;
	display: flex;
	height: 40px;
	justify-content: center;
	margin: 0 16px;
	white-space: nowrap;
	width: 40px;
	@media (max-width: 600px) {
		background-color: transparent;
		color: var(--text-color) !important;
		font-weight: 800;
	}
`;
const CarouselControlsWrapper = styled.div`
	align-items: center;
	display: flex;
	justify-content: flex-start;
	margin: 70px auto 15px !important;

	p {
		font-family: ${({ theme }) => theme.fontFamily.primary};
		font-size: 0.75rem;
		font-weight: ${({ theme }) => theme.fontWeight.black};
		line-height: 1rem;
	}
	@media (max-width: 600px) {
		justify-content: space-around;
		padding: 25px 0 !important;
		margin: 70px -15px 0 -15px !important;
		background-color: var(--background-grey);
		p {
			font-size: 0.85rem;
		}
	}
`;

const CarouselControls = ({ btnTextBack, numberOfPages, currentSlide, btnTextNext, next, prev, pageTheme }) => {
	const currentPageDesktop = Math.ceil(currentSlide / 3);
	const currentPageTablet = Math.ceil(currentSlide / 2);

	useEffect(() => {
		displaySlidesByResolution();
	});

	const displaySlidesByResolution = () => {
		if (isMobileOnly) {
			return currentSlide;
		} else if (isTablet) {
			return currentPageTablet;
		} else {
			return currentPageDesktop;
		}
	};

	return (
		<CarouselControlsWrapper>
			<ControlButton onClick={() => prev()}>{btnTextBack}</ControlButton>
			<CounterWrapper pageTheme={pageTheme}>
				<p>
					{displaySlidesByResolution()} / {numberOfPages}
				</p>
			</CounterWrapper>
			<ControlButton className="both-sides" onClick={() => next()}>
				{btnTextNext}
			</ControlButton>
		</CarouselControlsWrapper>
	);
};
export default CarouselControls;
